import { render } from "./Appheader.vue?vue&type=template&id=fe972c2c&scoped=true"
import script from "./Appheader.vue?vue&type=script&lang=js"
export * from "./Appheader.vue?vue&type=script&lang=js"

import "./Appheader.vue?vue&type=style&index=0&id=fe972c2c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.1.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe972c2c"]])

export default __exports__